var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 6.5a3.375 3.375 0 012.025 6.075L21.35 24.05a2.257 2.257 0 01-2.7 0L3.35 12.575A3.375 3.375 0 015.375 6.5h29.25zM17.3 25.85a4.493 4.493 0 005.4 0L38 14.375V29c0 2.482-2.018 4.5-4.5 4.5h-27A4.502 4.502 0 012 29V14.375L17.3 25.85z"
  })));
}
export default SvgEnvelopeSolid;